module.exports = __webpack_public_path__ + "img/bianci.5813051e.png";